module.exports = __webpack_public_path__ + "static/media/paypal.ea046c40.svg";